// extracted by mini-css-extract-plugin
export default {"suggest-feature-section":"styles_suggest-feature-section__QhHAd"};